import React, { useState } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import ViewAllOverlay from "./ViewAllOverlay";
import {
  PRODUCTS,
  PRODUCT_LAYOUT,
  getProductDescription,
} from "../data/products";

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

const ProductCard = ({ product, size, index, onOpen }) => {
  const sizeClasses = {
    hero: "col-span-2 row-span-2",
    large: "col-span-2 row-span-1",
    medium: "col-span-1 row-span-1",
    small: "col-span-1 row-span-1",
  };

  const imgHeightClasses = {
    hero: "h-[420px]",
    large: "h-[220px]",
    medium: "h-[200px]",
    small: "h-[180px]",
  };

  const titleSizeClasses = {
    hero: "text-2xl",
    large: "text-lg",
    medium: "text-base",
    small: "text-sm",
  };

  return (
    <>
      {product.category ? (
        <button
          type="button"
          onClick={() => onOpen(product)}
          className={`${sizeClasses[size]} group relative overflow-hidden bg-[#111] border border-[rgba(200,146,42,0.12)] hover:border-[rgba(200,146,42,0.4)] transition-all duration-500`}
          style={{ animationDelay: `${index * 80}ms` }}
        >
          <div
            className={`relative w-full ${imgHeightClasses[size]} overflow-hidden bg-[#0a0a0a]`}
          >
            <img
              src={product.image}
              alt={product.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent opacity-80" />
            <div className="absolute top-3 left-3">
              <span className="text-[9px] uppercase tracking-[0.2em] text-[#C8922A] bg-[rgba(0,0,0,0.7)] px-2 py-1 border border-[rgba(200,146,42,0.3)]">
                {product.category}
              </span>
            </div>
          </div>

          <div className="p-4">
            <h3
              className={`font-heading font-semibold text-white leading-tight ${titleSizeClasses[size]} group-hover:text-[#C8922A] transition-colors duration-300`}
            >
              {product.name}
            </h3>
          </div>

          <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-[#C8922A] group-hover:w-full transition-all duration-500" />
        </button>
      ) : (
        <div
          onClick={() => scrollToSection("contact")}
          className={`flex ${sizeClasses[size]} group relative overflow-hidden bg-[#111] border border-[rgba(200,146,42,0.12)] hover:border-[rgba(200,146,42,0.4)] transition-all duration-500`}
          style={{
            animationDelay: `${index * 80}ms`,
            textAlign: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {/* <div className="flex" style={{ margin: "3.5vh 3vw" }}>
            <h2 className="font-heading font-semibold text-white leading-tight text-2xl group-hover:text-[#C8922A] transition-colors duration-300">
              Looking for something else?
            </h2>
          </div> */}

          <Button
            onClick={() => scrollToSection("contact")}
            className="bg-[#c9923f] hover:bg-[#b8822e] text-white font-semibold px-8 py-6 text-base rounded transition-all"
          >
            Contact Us
          </Button>

          <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-[#C8922A] group-hover:w-full transition-all duration-500" />
        </div>
      )}
    </>
  );
};

const ProductsSection = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <section
      id="products"
      className="relative h-[65vh] bg-[#0D0D0D] overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[200px] bg-[rgba(200,146,42,0.04)] blur-[120px] rounded-full pointer-events-none" />

      <div className="h-full overflow-hidden">
        <div className="container mx-auto px-6 lg:px-12 pt-12 pb-8 h-full">
          <div className="mb-6 flex items-end justify-between">
            <div>
              <h2
                className="text-4xl lg:text-5xl font-bold text-white mb-3"
                style={{
                  fontSize: "clamp(24px, 3.5vw, 40px)",
                  lineHeight: 1.1,
                }}
              >
                Our Products
              </h2>
              <div className="h-[2px] w-12 bg-primary mt-3" />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-auto">
            {PRODUCT_LAYOUT.map((item, index) => {
              const product = PRODUCTS.find((p) => p.id === item.id);
              return (
                <ProductCard
                  key={product.id}
                  product={product}
                  size={item.size}
                  index={index}
                  onOpen={setSelectedProduct}
                />
              );
            })}
          </div>
        </div>
      </div>

      <ViewAllOverlay to="/products" />

      {/* <Dialog
        open={Boolean(selectedProduct)}
        onOpenChange={(open) => !open && setSelectedProduct(null)}
      >
        <DialogContent className="max-w-3xl bg-[#0D0D0D] border border-[rgba(200,146,42,0.35)] p-4 sm:p-6 text-white">
          {selectedProduct && (
            <div className="space-y-4">
              <DialogTitle className="sr-only">
                {selectedProduct.name}
              </DialogTitle>

              <div className="w-full rounded-md bg-[#111] p-2">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.alt}
                  className="w-full max-h-[75vh] object-contain"
                />
              </div>

              <div className="text-center space-y-2">
                <h3 className="font-heading text-2xl text-[#C8922A]">
                  {selectedProduct.name}
                </h3>
                <p className="text-sm sm:text-base text-gray-200">
                  {getProductDescription(selectedProduct)}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog> */}
    </section>
  );
};

export default ProductsSection;
